import { DIAMOND_BOX_STONE_DROPS } from "../data/balance.js";

/** 0~1 난수 소스 — 주입으로 테스트 결정론 확보. */
export type RandomSource = () => number;

export interface StoneDrop {
  readonly amount: number;
  readonly weight: number;
}

export interface DiamondUpgradeBoxState {
  readonly openCount: number;
}

/**
 * 다이아 강화 상자 (지시문 §7 방식 A·§16) — 개봉 시 범용 강화석 수량을 가중 추첨한다.
 * 순수 로직 (테스트 대상). 강화석 지급/강화 대상 선택은 호출자(인벤토리 탭) 책임.
 */
export class DiamondUpgradeBox {
  private _openCount: number;

  constructor(
    private readonly rng: RandomSource = Math.random,
    private readonly drops: readonly StoneDrop[] = DIAMOND_BOX_STONE_DROPS,
    initial?: DiamondUpgradeBoxState,
  ) {
    this._openCount = initial?.openCount ?? 0;
  }

  get openCount(): number {
    return this._openCount;
  }

  /** 1회 개봉 → 지급할 강화석 수량. */
  open(): number {
    this._openCount += 1;
    const total = this.drops.reduce((s, d) => s + d.weight, 0);
    let roll = this.rng() * total;
    for (const d of this.drops) {
      roll -= d.weight;
      if (roll < 0) return d.amount;
    }
    return this.drops[this.drops.length - 1]?.amount ?? 1;
  }

  toState(): DiamondUpgradeBoxState {
    return { openCount: this._openCount };
  }
}
